module.exports = __webpack_public_path__ + "static/media/pipeCalculation.137360a4.svg";